import { createModel } from '@rematch/core';
import { selectors } from './selector';
import { RootState } from '../../store';
import { CounselingType } from '../../models/counseling-type';
import { storeByIMPSId } from '../../utils/converter';
import { getCounselingTypes } from '../../apis/emr-data';

export interface State {
    allIds: number[];
    byId: Dictionary<CounselingType>;
    loading: Dictionary<boolean>;
}

export const counselingTypes = createModel<State>({
    state: {
        allIds: [],
        byId: {},
        loading: {}
    },
    reducers: {
        update: (
            state: State,
            data: CounselingType[],
            loadingKey?: string
        ): State => {
            const hasData = Array.isArray(data) ? data.length > 0 : data;
            if (hasData || loadingKey) {
                const byId = {
                    ...state.byId,
                    ...storeByIMPSId(data)
                };
                return {
                    ...state,
                    allIds: Object.keys(byId).map(x => +x),
                    byId: byId,
                    ...loadingKey && {
                        loading: {
                            ...state.loading,
                            [loadingKey]: false
                        }
                    }
                };
            } else {
                return state;
            }
        },
        loading: (
            state: State,
            loadingKey: string,
            loading: boolean
        ): State => ({
            ...state,
            loading: {
                ...state.loading,
                [loadingKey]: loading
            }
        })
    },
    effects: () => ({
        async getCounselingTypesAsync(
            _: Undefinable<{}>,
            rootState: RootState
        ) {
            if (selectors.getCounselingTypeIds(rootState.counselingTypes).length === 0) {
                try {
                    const data = await getCounselingTypes();
                    this.update(data);
                } catch (e) {
                    window.console.log(e);
                }
            }
        }
    })
});
